import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '@components/index'
import { useYupValidation } from '@hooks/index'
import { forgotPasswordSchema } from '@yupSchemas/index'
import { IAuthForgotPass } from '@interfaces/index'
import logo from '@assets/images/logo.png'
import { errorHandler, AuthService } from '@services/index'
import { toast } from 'react-toastify'

export default function ForgotPassaword(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthForgotPass>({
        resolver: useYupValidation(forgotPasswordSchema),
    })

    async function emailConfirmation(values: IAuthForgotPass): Promise<void> {
        setIsLoading(true)
        try {
            await AuthService.emailConfirmation(values)
            navigate('/recovery-code', { state: values.email })
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="box-forgotPass">
            <div className="forgotPass__background">
                <div className="forgotPass__content">
                    <div className="forgotPass__images">
                        <img src={logo} alt="Logo CNA construtora" className="forgotPass__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Informe o e-mail cadastrado</h4>
                    <form id="forgotPass__form" onSubmit={handleSubmit(emailConfirmation)}>
                        <div className="forgotPass__inputs">
                            <Controller
                                name="email"
                                defaultValue={''}
                                control={control}
                                render={({ field: { value, onChange } }) => {
                                    return <InputForm size='small' placeholder="E-mail" label="E-mail" name="email" value={value} onChange={onChange} />
                                }}
                            />
                            <ErrorForm error={errors.email?.message} />
                        </div>
                        <div className="box-buttons-forgot">
                            <Button secondary type={'button'} placeholder="Cancelar" onClick={() => navigate('/')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Enviar e-mail" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
